module.exports = __webpack_public_path__ + "static/media/twitterSmallIcon.6a9e7428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/twitterSmallIcon.svg
// module id = 1815
// module chunks = 0